import { useContext } from 'react';
import { transactionContext } from '../contexts/TransactionContext';

export function useTransaction() {
  const value = useContext(transactionContext);
  return value;
}
